
export default function WhatsAppButton() {
  const handleWhatsAppClick = () => {
    const phoneNumber = '5511987654321';
    const message = 'Olá! Gostaria de saber mais sobre os serviços da Persona Pro.';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <button
      onClick={handleWhatsAppClick}
      className="fixed bottom-6 right-6 w-16 h-16 bg-[#25D366] rounded-full shadow-2xl flex items-center justify-center hover:bg-[#20BA5A] transition-all transform hover:scale-110 z-50 cursor-pointer group"
      aria-label="Contato via WhatsApp"
    >
      <i className="ri-whatsapp-line text-3xl text-white"></i>
      <span className="absolute right-20 bg-gray-900 text-white px-4 py-2 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        Fale conosco!
      </span>
    </button>
  );
}
